// extracted by mini-css-extract-plugin
export default {"root":"opening-hours_root__6rm9h"};